import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["value"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'base-select',
    props: {
        modelValue: {},
        value: {}
    },
    emits: ["update:modelValue", "change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const inputListeners = {
            change: (event) => {
                const target = event.target;
                const nextValue = target?.value ?? '';
                emit('update:modelValue', nextValue);
                emit('change', nextValue, event);
            }
        };
        const currentValue = computed(() => (props.value !== undefined ? props.value : props.modelValue));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("select", _mergeProps(_ctx.$attrs, {
                value: currentValue.value,
                class: _ctx.$style.select
            }, _toHandlers(inputListeners, true)), [
                _renderSlot(_ctx.$slots, "default")
            ], 16, _hoisted_1));
        };
    }
});
